import { waLink } from "@/lib/site";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Falar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 group-hover:opacity-0 animate-ping" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20 hover:scale-105 transition-transform">
        <svg viewBox="0 0 32 32" className="h-6 w-6" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.49-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.04 1.348-1.04 2.292 0 .94.4 1.853.928 2.65 1.04 1.49 2.92 3.07 4.56 3.97.7.4 2.55 1.198 3.32 1.198.59 0 1.59-.295 1.92-.86.2-.345.2-.645.143-.93-.066-.198-.245-.367-.516-.61-.297-.243-.696-.43-1.04-.43z"/>
          <path d="M16 0C7.16 0 0 7.16 0 16c0 2.8.73 5.55 2.12 7.97L.05 31.93l8.16-2.14A15.9 15.9 0 0 0 16 32c8.84 0 16-7.16 16-16S24.84 0 16 0zm0 29.34a13.3 13.3 0 0 1-6.78-1.85l-.49-.29-5.04 1.32 1.34-4.91-.32-.5A13.34 13.34 0 1 1 29.34 16c0 7.36-5.98 13.34-13.34 13.34z"/>
        </svg>
      </span>
    </a>
  );
}
